// extracted by mini-css-extract-plugin
export default {"animate-slide-in":"Toast_animate-slide-in__Bw11n","slideIn":"Toast_slideIn__TPd8f"};